/**
 * Whether the current page is a sales-mirror checkout URL — /sales/checkout/*
 * or /sales/offer/* (INT-56).
 *
 * On these routes every client-side marketing tracker is suppressed and the
 * backend is told (via a `channel: "sales"` signal on its requests) to keep
 * only LeadSquared — no WhatsApp/Slack/Pabbly/cart-recovery — and to stamp
 * analytics `isSales` so they never reach the founder dashboard.
 *
 * Read straight from the URL so the inline gate in public/index.html and the
 * React code always agree on a direct page load. These are direct-entry
 * landing pages; there is no in-app navigation between the /sales and the
 * public families, so reading pathname at load is sufficient.
 */
export const isSalesRoute = () => {
  try {
    return /^\/sales\//.test(window.location.pathname);
  } catch {
    return false;
  }
};

export default isSalesRoute;
